import { controls } from "../../controls";
                           
const rp807 = {
  label: "Dividend Warrant Printing",
  pageLabel: "Dividend Warrant Printing",
  starting: true,
  url: "rp807",
 
  pageType: "history",
  filter: [

    ...controls.displayText({tab: "filter",label: "Warrant Year",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"warrant_year",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-8"}),

     ...controls.displayText({ tab: "filter", label: "Member Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "select", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),   
  
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-8 "}),

    ...controls.displayText({ tab: "filter", label: "Member Number From-To", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number_from", width: "col-sm-1" }),
    
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-0" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number_to", width: "col-sm-1" }),   
    
      ...controls.displayText({tab: "filter",label: "",width:"col-sm-8"}),

     ...controls.displayText({ tab: "filter", label: "Amount From-To", width: "col-sm-2" }),
      ...controls.numberOnly({ tab: "filter", name: "amount_from", width: "col-sm-1" }),    
       
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-0" }),
    ...controls.numberOnly({ tab: "filter", name: "amount_to", width: "col-sm-1" }),    

  ...controls.displayText({tab: "filter",label: "",width:"col-sm-8"}),

     ...controls.displayText({ tab: "filter", label: "Divident Transfer To", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "select", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Having A/C No.",
        value: "having_acctcode"
      },
      {
        label: "Having Active A/C No.",
        value: "having_active_acctcode"
      },
      {
        label: "Not Having A/C No.",
        value: "not_having_acctcode"
      }]
    }),       

    
    

   
  ],

  form:[],

  history: {
    perPage: 10,
    reportHeader: "Dividend Warrant Printing",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [

      { 
            Header: "Sr",        
            type: "autoinc",
            accessor: "srno",
            width: 30      
      },
      
      {
        Header: "Warrant",
        accessor: "warrant",
        
      },
      {
        Header: "Member No",
        accessor: "member_no"
       
      },

      {
        Header: "Discription",
        accessor: "discription",
        
      },

            
     

            
      {
        Header: "No Of Shares",
        accessor: "no_of_shars",
        
      },
      
      {
        Header: "Dividend",
        accessor: "dividend",
        type: "currancy"
      },
    
      {
        Header: "Address 1",
        accessor: "address_1",
        
      },
      {
        Header: "Address 2",
        accessor: "address_2",
        
      },
    
      {
        Header: "Address 3",
        accessor: "address_3",
        
      },
    
      
    ]
  }
};

export default rp807;